<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Resposta' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <div *ngFor="let resposta of respostas">
    <ion-card *ngIf="resposta">
      <ion-grid>
        <ion-row class="ion-row-border">
          <ion-col>
            <ion-item lines="none">
              <ion-avatar slot="start">
                <img src="{{resposta.criador.foto | image:''}}" class="avatar-image" />
              </ion-avatar>

              <ion-label>
                <h2 class="titulo">{{resposta.titulo}}</h2>
                <p class="data">{{resposta.criador.nome}}</p>
                <p class="data">
                  {{resposta.created_at | dateFormat:"mediaHora"}}
                </p>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="ion-padding-start">
            <p class="text-content" [innerHTML]="resposta.conteudo | safeHtml: 'html'"></p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>

    <ion-card *ngIf="!resposta">
      <sem-registro></sem-registro>
    </ion-card>
  </div>

  <div *ngIf="!respostas">
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-grid>
        <ion-row class="remove-border ion-padding-top">
          <ion-col>
            <ion-item>
              <ion-label position="stacked" class="titulo ion-padding"
                >{{'Resposta' | translate}} <span style="color: #0041e8;">*</span>
              </ion-label>
              <ion-textarea
                class="ion-row-border"
                rows="5"
                cols="60"
                type="text"
                formControlName="resposta"
                label=""
              ></ion-textarea>

              <div class="validation-errors">
                <ng-container *ngFor="let validation of validation_messages.resposta">
                  <div
                    class="error-message"
                    *ngIf="validations_form.get('resposta')?.hasError(validation.type) && (validations_form.get('resposta')?.dirty || validations_form.get('resposta')?.touched)"
                  >
                    {{ validation.message }}
                  </div>
                </ng-container>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row class="remove-border ion-padding-top ion-justify-content-center">
          <ion-col size="12">
            <ion-item *ngIf="liberado_inicial">
              <ion-label class="alinhamento" style="font-size: 12px">
                {{'Liberar para listagem pública' | translate}}
                <ion-toggle
                  class="alinhamento"
                  label=""
                  [enableOnOffLabels]="true"
                  [(ngModel)]="liberado_inicial"
                  [checked]="liberado_inicial"
                  formControlName="liberado"
                ></ion-toggle>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="7">
            <div class="down">
              <ion-button
                class="btn-success btn-edit"
                type="submit"
                [disabled]="!validations_form.valid"
                >{{'Salvar' | translate}}</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </div>
</ion-content>
